import { Alert, Button, Form, Input } from 'antd';
import { Lock } from 'lucide-react';
import { useState } from 'react';

interface TurnOffWithPasswordProps {
  error: string | null;
  submitting: boolean;
  onConfirm: (password: string) => Promise<boolean>;
}

/** "Turn off", then the password inline: a hijacked session alone must not be able to drop a second factor. */
export function TurnOffWithPassword({ error, submitting, onConfirm }: TurnOffWithPasswordProps) {
  const [isConfirming, setIsConfirming] = useState(false);

  async function submit(values: { password: string }) {
    if (await onConfirm(values.password)) setIsConfirming(false);
  }

  if (!isConfirming) {
    return (
      <Button className="mt-5" danger onClick={() => setIsConfirming(true)}>
        Turn off
      </Button>
    );
  }

  return (
    <div className="mt-5 max-w-xs">
      {error && <Alert className="mb-4" type="error" title={error} showIcon />}
      <Form<{ password: string }> layout="vertical" requiredMark={false} onFinish={submit} disabled={submitting}>
        <Form.Item name="password" label="Confirm your password" rules={[{ required: true }]}>
          <Input.Password prefix={<Lock className="size-4 text-muted" />} autoComplete="current-password" autoFocus />
        </Form.Item>
        <div className="flex gap-2">
          <Button danger htmlType="submit" loading={submitting}>
            Turn off
          </Button>
          <Button onClick={() => setIsConfirming(false)} disabled={submitting}>
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
}
